var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Close-2",
    "data-name": "Close",
    d: "M-885.554-890.276a.654.654,0,0,1-.466-.194.668.668,0,0,1,0-.937l2.8-2.827-2.875-2.913a.664.664,0,0,1,0-.936.65.65,0,0,1,.465-.194.653.653,0,0,1,.466.194l2.875,2.922,2.876-2.889a.651.651,0,0,1,.465-.194.654.654,0,0,1,.466.194.666.666,0,0,1,0,.937l-2.875,2.88,2.8,2.818a.665.665,0,0,1,0,.936.653.653,0,0,1-.466.194.65.65,0,0,1-.465-.194l-2.8-2.809-2.8,2.819A.654.654,0,0,1-885.554-890.276Z",
    transform: "translate(887.79 899.78)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CloseIcon.90e4cf99d0c6e819eba29ef76677f8aa.svg";